import asyncSessionLoader from "../../../gd/data/async-session-loader"
import FinderTasksCollection from "../../../model2/task/finder/collection";
import ApiFinder from "../../../gd/api/finder"

const debug = false
// const debug = "finderLoadProjectTasks"

export function finderLoadProjectTasks(parentProjectId: ID, statusId: string, excludedTasksIds: ID[] = []): Promise<FinderTasksCollection> {
    debug && console.log(debug, 'process')

    return new Promise(async (resolve, reject) => {
        const response = await ApiFinder.tasks(parentProjectId, statusId === 'open').promise()

        const data  = _.filter(response, t=>!excludedTasksIds.includes(t.id))
        _.map(data, (item:any)=>item.projectId = parentProjectId)

        await asyncSessionLoader(findMissingData(data))
        const collection:FinderTasksCollection  = FinderTasksCollection.initFromJson(data)

        debug && console.log(debug, 'loadedData', collection)

        resolve(collection)
    })
}

function findMissingData(tasks: any[]) {
    if (!tasks) return false
    let uniqueTaskTypes = _.uniq(_.map(tasks, 'taskTypeId'))

    return gd.session.findMissing({
        taskTypes: uniqueTaskTypes
    })
}